exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.show-overflow.ant-collapse-item.ant-collapse-item-active > .ant-collapse-content {\n  overflow: visible !important;\n}\n", ""]);

// exports
